import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const Activate = ({ classes }) => {
  return (
    <Grid container alignItems="center" direction="column" className={classes.root}>
      <Grid item xs={10} lg={6}>
        <h2 className={classes.headerText}>Your account is not activated.</h2>

        <p className={classes.subtext}>
          Thanks for taking the time to use Qwell! We see that you have an account but it is not yet activated.

          If you think this is a mistake please reach out to your Account Manager or send us an email
          at <a href="mailto:help@qwell.com?Subject=Account%20Access%20Problems" target="_top">help@qwell.com</a>.
        </p>

        <p className={classes.subtext}>
          To learn more about what it means to be Qwell Provider
          click <a href={process.env.REACT_APP_HOMEPAGE_URL + "/for-providers"} target="_blank" rel="noopener noreferrer">here</a>.
        </p>
      </Grid>
    </Grid>
  );
};

const styles = () => ({
  root: {
    paddingTop: '5em',
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '16px',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

export default withStyles(styles)(Activate);
